import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '~/lib/utils';

export const xpIconVariants = cva('shrink-0', {
  variants: {
    size: {
      default: 'size-6',
      sm: 'size-4.5',
      xs: 'size-4',
      lg: 'size-12',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

export type XpIconProps = React.ComponentProps<'img'> & VariantProps<typeof xpIconVariants>;

export function XpIcon({ size, className, ...props }: XpIconProps) {
  return (
    <img
      data-slot="xp-icon"
      src="/assets/gamification/xp.svg"
      alt=""
      className={cn(xpIconVariants({ size }), className)}
      {...props}
    />
  );
}
